module.exports = __webpack_public_path__ + "static/img/policyDetail.aa155d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/policyDetail.png
// module id = CNz8
// module chunks = 44